module.exports = __webpack_public_path__ + "img/TZS09582.922ccd1a.jpeg";